/* eslint-disable max-len */
const countriesData = 
[
    {
        "country_name": "Algeria",
        "iso_code": "DZ",
        "currency": "DZD",
        "currency_symbol": "$",
        "phone_code": 213,
        "country_phone_number_length": 9,
        "nationality": "Algeria"
    },
    {
        "country_name": "Argentina",
        "iso_code": "AR",
        "currency": "ARS",
        "currency_symbol": "$",
        "phone_code": 54,
        "country_phone_number_length": 10,
        "nationality": "Argentina"
    },
    {
        "country_name": "Armenia",
        "iso_code": "AM",
        "currency": "AMD",
        "currency_symbol": "$",
        "phone_code": 374,
        "country_phone_number_length": 10,
        "nationality": "Armenia"
    },
    {
        "country_name": "Australia",
        "iso_code": "AU",
        "currency": "AUD",
        "currency_symbol": "$",
        "phone_code": 61,
        "country_phone_number_length": 9,
        "nationality": "Australian"
    },
    {
        "country_name": "Austria",
        "iso_code": "AT",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 43,
        "country_phone_number_length": 10,
        "nationality": "Austrian"
    },
    {
        "country_name": "Azerbaijan",
        "iso_code": "AZ",
        "currency": "AZN",
        "currency_symbol": "$",
        "phone_code": 994,
        "country_phone_number_length": 10,
        "nationality": "Azerbaijan"
    },
    {
        "country_name": "Bahamas The",
        "iso_code": "BS",
        "currency": "BSD",
        "currency_symbol": "$",
        "phone_code": "+1-242",
        "country_phone_number_length": 10,
        "nationality": "Bahamas The"
    },
    {
        "country_name": "Bahrain",
        "iso_code": "BH",
        "currency": "BHD",
        "currency_symbol": "$",
        "phone_code": 973,
        "country_phone_number_length": 8,
        "nationality": "Bahrain"
    },
    {
        "country_name": "Bangladesh",
        "iso_code": "BD",
        "currency": "BDT",
        "currency_symbol": "$",
        "phone_code": 880,
        "country_phone_number_length": 10,
        "nationality": "Bangladesh"
    },
    {
        "country_name": "Barbados",
        "iso_code": "BB",
        "currency": "BBD",
        "currency_symbol": "$",
        "phone_code": "+1-246",
        "country_phone_number_length": 10,
        "nationality": "Barbados"
    },
    {
        "country_name": "Belarus",
        "iso_code": "BY",
        "currency": "BYN",
        "currency_symbol": "$",
        "phone_code": 375,
        "country_phone_number_length": 10,
        "nationality": "Belarus"
    },
    {
        "country_name": "Belgium",
        "iso_code": "BE",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 32,
        "country_phone_number_length": 9,
        "nationality": "Belgium"
    },
    {
        "country_name": "Belize",
        "iso_code": "BZ",
        "currency": "BZD",
        "currency_symbol": "$",
        "phone_code": 501,
        "country_phone_number_length": 10,
        "nationality": "Belize"
    },
    {
        "country_name": "Benin",
        "iso_code": "BJ",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 229,
        "country_phone_number_length": 10,
        "nationality": "Benin"
    },
    {
        "country_name": "Bermuda",
        "iso_code": "BM",
        "currency": "BMD",
        "currency_symbol": "$",
        "phone_code": "+1-441",
        "country_phone_number_length": 10,
        "nationality": "Bermuda"
    },
    {
        "country_name": "Bhutan",
        "iso_code": "BT",
        "currency": "BTN",
        "currency_symbol": "$",
        "phone_code": 975,
        "country_phone_number_length": 10,
        "nationality": "Bhutan"
    },
    {
        "country_name": "Bolivia",
        "iso_code": "BO",
        "currency": "BOB",
        "currency_symbol": "$",
        "phone_code": 591,
        "country_phone_number_length": 10,
        "nationality": "Bolivia"
    },
    {
        "country_name": "Bosnia and Herzegovina",
        "iso_code": "BA",
        "currency": "BAM",
        "currency_symbol": "$",
        "phone_code": 387,
        "country_phone_number_length": 10,
        "nationality": "Bosnia and Herzegovina"
    },
    {
        "country_name": "Botswana",
        "iso_code": "BW",
        "currency": "BWP",
        "currency_symbol": "$",
        "phone_code": 267,
        "country_phone_number_length": 10,
        "nationality": "Botswana"
    },
    {
        "country_name": "Bouvet Island",
        "iso_code": "BV",
        "currency": "NOK",
        "currency_symbol": "$",
        "phone_code": 55,
        "country_phone_number_length": 10,
        "nationality": "Bouvet Island"
    },
    {
        "country_name": "Brazil",
        "iso_code": "BR",
        "currency": "BRL",
        "currency_symbol": "$",
        "phone_code": 55,
        "country_phone_number_length": 10,
        "nationality": "Brazil"
    },
    {
        "country_name": "British Indian Ocean Territory",
        "iso_code": "IO",
        "currency": "USD",
        "currency_symbol": "$",
        "phone_code": 246,
        "country_phone_number_length": 10,
        "nationality": "British Indian Ocean Territory"
    },
    {
        "country_name": "Brunei",
        "iso_code": "BN",
        "currency": "BND",
        "currency_symbol": "$",
        "phone_code": 673,
        "country_phone_number_length": 10,
        "nationality": "Brunei"
    },
    {
        "country_name": "Bulgaria",
        "iso_code": "BG",
        "currency": "BGN",
        "currency_symbol": "$",
        "phone_code": 359,
        "country_phone_number_length": 10,
        "nationality": "Bulgaria"
    },
    {
        "country_name": "Burkina Faso",
        "iso_code": "BF",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 226,
        "country_phone_number_length": 10,
        "nationality": "Burkina Faso"
    },
    {
        "country_name": "Burundi",
        "iso_code": "BI",
        "currency": "BIF",
        "currency_symbol": "$",
        "phone_code": 257,
        "country_phone_number_length": 10,
        "nationality": "Burundi"
    },
    {
        "country_name": "Cambodia",
        "iso_code": "KH",
        "currency": "KHR",
        "currency_symbol": "$",
        "phone_code": 855,
        "country_phone_number_length": 10,
        "nationality": "Cambodia"
    },
    {
        "country_name": "Cameroon",
        "iso_code": "CM",
        "currency": "XAF",
        "currency_symbol": "$",
        "phone_code": 237,
        "country_phone_number_length": 10,
        "nationality": "Cameroon"
    },
    {
        "country_name": "Canada",
        "iso_code": "CA",
        "currency": "CAD",
        "currency_symbol": "$",
        "phone_code": 1,
        "country_phone_number_length": 10,
        "nationality": "Canada"
    },
    {
        "country_name": "Cape Verde",
        "iso_code": "CV",
        "currency": "CVE",
        "currency_symbol": "$",
        "phone_code": 238,
        "country_phone_number_length": 10,
        "nationality": "Cape Verde"
    },
    {
        "country_name": "Cayman Islands",
        "iso_code": "KY",
        "currency": "KYD",
        "currency_symbol": "$",
        "phone_code": "+1-345",
        "country_phone_number_length": 10,
        "nationality": "Cayman Islands"
    },
    {
        "country_name": "Central African Republic",
        "iso_code": "CF",
        "currency": "XAF",
        "currency_symbol": "$",
        "phone_code": 236,
        "country_phone_number_length": 10,
        "nationality": "Central African Republic"
    },
    {
        "country_name": "Chad",
        "iso_code": "TD",
        "currency": "XAF",
        "currency_symbol": "$",
        "phone_code": 235,
        "country_phone_number_length": 10,
        "nationality": "Chad"
    },
    {
        "country_name": "Chile",
        "iso_code": "CL",
        "currency": "CLP",
        "currency_symbol": "$",
        "phone_code": 56,
        "country_phone_number_length": 10,
        "nationality": "Chile"
    },
    {
        "country_name": "China",
        "iso_code": "CN",
        "currency": "CNY",
        "currency_symbol": "$",
        "phone_code": 86,
        "country_phone_number_length": 11,
        "nationality": "Chinese"
    },
    {
        "country_name": "Christmas Island",
        "iso_code": "CX",
        "currency": "AUD",
        "currency_symbol": "$",
        "phone_code": 61,
        "country_phone_number_length": 10,
        "nationality": "Christmas Island"
    },
    {
        "country_name": "Cocos (Keeling) Islands",
        "iso_code": "CC",
        "currency": "AUD",
        "currency_symbol": "$",
        "phone_code": 61,
        "country_phone_number_length": 10,
        "nationality": "Cocos (Keeling) Islands"
    },
    {
        "country_name": "Colombia",
        "iso_code": "CO",
        "currency": "COP",
        "currency_symbol": "$",
        "phone_code": 57,
        "country_phone_number_length": 10,
        "nationality": "Colombia"
    },
    {
        "country_name": "Comoros",
        "iso_code": "KM",
        "currency": "KMF",
        "currency_symbol": "$",
        "phone_code": 269,
        "country_phone_number_length": 10,
        "nationality": "Comoros"
    },
    {
        "country_name": "Congo",
        "iso_code": "CG",
        "currency": "XAF",
        "currency_symbol": "$",
        "phone_code": 242,
        "country_phone_number_length": 10,
        "nationality": "Congo"
    },
    {
        "country_name": "Congo The Democratic Republic Of The",
        "iso_code": "CD",
        "currency": "CDF",
        "currency_symbol": "$",
        "phone_code": 243,
        "country_phone_number_length": 10,
        "nationality": "Congo The Democratic Republic Of The"
    },
    {
        "country_name": "Cook Islands",
        "iso_code": "CK",
        "currency": "NZD",
        "currency_symbol": "$",
        "phone_code": 682,
        "country_phone_number_length": 10,
        "nationality": "Cook Islands"
    },
    {
        "country_name": "Costa Rica",
        "iso_code": "CR",
        "currency": "CRC",
        "currency_symbol": "$",
        "phone_code": 506,
        "country_phone_number_length": 10,
        "nationality": "Costa Rica"
    },
    {
        "country_name": "Cote D'Ivoire (Ivory Coast)",
        "iso_code": "CI",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 225,
        "country_phone_number_length": 10,
        "nationality": "Cote D'Ivoire (Ivory Coast)"
    },
    {
        "country_name": "Croatia (Hrvatska)",
        "iso_code": "HR",
        "currency": "HRK",
        "currency_symbol": "$",
        "phone_code": 385,
        "country_phone_number_length": 10,
        "nationality": "Croatia (Hrvatska)"
    },
    {
        "country_name": "Cuba",
        "iso_code": "CU",
        "currency": "CUP",
        "currency_symbol": "$",
        "phone_code": 53,
        "country_phone_number_length": 10,
        "nationality": "Cuba"
    },
    {
        "country_name": "Cyprus",
        "iso_code": "CY",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 357,
        "country_phone_number_length": 10,
        "nationality": "Cyprus"
    },
    {
        "country_name": "Czech Republic",
        "iso_code": "CZ",
        "currency": "CZK",
        "currency_symbol": "$",
        "phone_code": 420,
        "country_phone_number_length": 10,
        "nationality": "Czech Republic"
    },
    {
        "country_name": "Denmark",
        "iso_code": "DK",
        "currency": "DKK",
        "currency_symbol": "$",
        "phone_code": 45,
        "country_phone_number_length": 10,
        "nationality": "Denmark"
    },
    {
        "country_name": "Djibouti",
        "iso_code": "DJ",
        "currency": "DJF",
        "currency_symbol": "$",
        "phone_code": 253,
        "country_phone_number_length": 10,
        "nationality": "Djibouti"
    },
    {
        "country_name": "Dominica",
        "iso_code": "DM",
        "currency": "XCD",
        "currency_symbol": "$",
        "phone_code": "+1-767",
        "country_phone_number_length": 10,
        "nationality": "Dominica"
    },
    {
        "country_name": "Dominican Republic",
        "iso_code": "DO",
        "currency": "DOP",
        "currency_symbol": "$",
        "phone_code": "+1-809",
        "country_phone_number_length": 10,
        "nationality": "Dominican Republic"
    },
    {
        "country_name": "East Timor",
        "iso_code": "TL",
        "currency": "USD",
        "currency_symbol": "$",
        "phone_code": 670,
        "country_phone_number_length": 10,
        "nationality": "East Timor"
    },
    {
        "country_name": "Ecuador",
        "iso_code": "EC",
        "currency": "USD",
        "currency_symbol": "$",
        "phone_code": 593,
        "country_phone_number_length": 10,
        "nationality": "Ecuador"
    },
    {
        "country_name": "Egypt",
        "iso_code": "EG",
        "currency": "EGP",
        "currency_symbol": "$",
        "phone_code": 20,
        "country_phone_number_length": 10,
        "nationality": "Egypt"
    },
    {
        "country_name": "El Salvador",
        "iso_code": "SV",
        "currency": "USD",
        "currency_symbol": "$",
        "phone_code": 503,
        "country_phone_number_length": 10,
        "nationality": "El Salvador"
    },
    {
        "country_name": "Equatorial Guinea",
        "iso_code": "GQ",
        "currency": "XAF",
        "currency_symbol": "$",
        "phone_code": 240,
        "country_phone_number_length": 10,
        "nationality": "Equatorial Guinea"
    },
    {
        "country_name": "Eritrea",
        "iso_code": "ER",
        "currency": "ERN",
        "currency_symbol": "$",
        "phone_code": 291,
        "country_phone_number_length": 10,
        "nationality": "Eritrea"
    },
    {
        "country_name": "Estonia",
        "iso_code": "EE",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 372,
        "country_phone_number_length": 10,
        "nationality": "Estonia"
    },
    {
        "country_name": "Ethiopia",
        "iso_code": "ET",
        "currency": "ETB",
        "currency_symbol": "$",
        "phone_code": 251,
        "country_phone_number_length": 10,
        "nationality": "Ethiopia"
    },
    {
        "country_name": "Falkland Islands",
        "iso_code": "FK",
        "currency": "FKP",
        "currency_symbol": "$",
        "phone_code": 500,
        "country_phone_number_length": 10,
        "nationality": "Falkland Islands"
    },
    {
        "country_name": "Faroe Islands",
        "iso_code": "FO",
        "currency": "DKK",
        "currency_symbol": "$",
        "phone_code": 298,
        "country_phone_number_length": 10,
        "nationality": "Faroe Islands"
    },
    {
        "country_name": "Fiji Islands",
        "iso_code": "FJ",
        "currency": "FJD",
        "currency_symbol": "$",
        "phone_code": 679,
        "country_phone_number_length": 10,
        "nationality": "Fiji Islands"
    },
    {
        "country_name": "Finland",
        "iso_code": "FI",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 358,
        "country_phone_number_length": 10,
        "nationality": "Finland"
    },
    {
        "country_name": "France",
        "iso_code": "FR",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 33,
        "country_phone_number_length": 10,
        "nationality": "France"
    },
    {
        "country_name": "French Guiana",
        "iso_code": "GF",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 594,
        "country_phone_number_length": 10,
        "nationality": "French Guiana"
    },
    {
        "country_name": "French Polynesia",
        "iso_code": "PF",
        "currency": "XPF",
        "currency_symbol": "$",
        "phone_code": 689,
        "country_phone_number_length": 10,
        "nationality": "French Polynesia"
    },
    {
        "country_name": "Germany",
        "iso_code": "DE",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 49,
        "country_phone_number_length": 10,
        "nationality": "Germany"
    },
    {
        "country_name": "Ghana",
        "iso_code": "GH",
        "currency": "GHS",
        "currency_symbol": "$",
        "phone_code": 233,
        "country_phone_number_length": 10,
        "nationality": "Ghana"
    },
    {
        "country_name": "Greece",
        "iso_code": "GR",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 30,
        "country_phone_number_length": 10,
        "nationality": "Greece"
    },
    {
        "country_name": "Greenland",
        "iso_code": "GL",
        "currency": "DKK",
        "currency_symbol": "$",
        "phone_code": 299,
        "country_phone_number_length": 10,
        "nationality": "Greenland"
    },
    {
        "country_name": "Grenada",
        "iso_code": "GD",
        "currency": "XCD",
        "currency_symbol": "$",
        "phone_code": "+1-473",
        "country_phone_number_length": 10,
        "nationality": "Grenada"
    },
    {
        "country_name": "Guadeloupe",
        "iso_code": "GP",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 590,
        "country_phone_number_length": 10,
        "nationality": "Guadeloupe"
    },
    {
        "country_name": "Guernsey and Alderney",
        "iso_code": "GG",
        "currency": "GBP",
        "currency_symbol": "$",
        "phone_code": "+44-1481",
        "country_phone_number_length": 10,
        "nationality": "Guernsey and Alderney"
    },
    {
        "country_name": "Honduras",
        "iso_code": "HN",
        "currency": "HNL",
        "currency_symbol": "$",
        "phone_code": 504,
        "country_phone_number_length": 10,
        "nationality": "Honduras"
    },
    {
        "country_name": "Hong Kong S.A.R.",
        "iso_code": "HK",
        "currency": "HKD",
        "currency_symbol": "$",
        "phone_code": 852,
        "country_phone_number_length": 10,
        "nationality": "Hong Kong S.A.R."
    },
    {
        "country_name": "Hungary",
        "iso_code": "HU",
        "currency": "HUF",
        "currency_symbol": "$",
        "phone_code": 36,
        "country_phone_number_length": 10,
        "nationality": "Hungary"
    },
    {
        "country_name": "Iceland",
        "iso_code": "IS",
        "currency": "ISK",
        "currency_symbol": "$",
        "phone_code": 354,
        "country_phone_number_length": 10,
        "nationality": "Iceland"
    },
    {
        "country_name": "India",
        "iso_code": "IN",
        "currency": "INR",
        "currency_symbol": "₹",
        "phone_code": 91,
        "country_phone_number_length": 10,
        "nationality": "Indian"
    },
    {
        "country_name": "Indonesia",
        "iso_code": "ID",
        "currency": "IDR",
        "currency_symbol": "$",
        "phone_code": 62,
        "country_phone_number_length": 10,
        "nationality": "Indonesian"
    },
    {
        "country_name": "Iran",
        "iso_code": "IR",
        "currency": "IRR",
        "currency_symbol": "$",
        "phone_code": 98,
        "country_phone_number_length": 10,
        "nationality": "Iranian"
    },
    {
        "country_name": "Iraq",
        "iso_code": "IQ",
        "currency": "IQD",
        "currency_symbol": "$",
        "phone_code": 964,
        "country_phone_number_length": 10,
        "nationality": "Iraqi"
    },
    {
        "country_name": "Ireland",
        "iso_code": "IE",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 353,
        "country_phone_number_length": 10,
        "nationality": "Irish"
    },
    {
        "country_name": "Israel",
        "iso_code": "IL",
        "currency": "ILS",
        "currency_symbol": "$",
        "phone_code": 972,
        "country_phone_number_length": 10,
        "nationality": "Israeli"
    },
    {
        "country_name": "Italy",
        "iso_code": "IT",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 39,
        "country_phone_number_length": 10,
        "nationality": "Italian"
    },
    {
        "country_name": "Jamaica",
        "iso_code": "JM",
        "currency": "JMD",
        "currency_symbol": "$",
        "phone_code": "+1-876",
        "country_phone_number_length": 10,
        "nationality": "Jamaican"
    },
    {
        "country_name": "Japan",
        "iso_code": "JP",
        "currency": "JPY",
        "currency_symbol": "$",
        "phone_code": 81,
        "country_phone_number_length": 10,
        "nationality": "Japanese"
    },
    {
        "country_name": "Jordan",
        "iso_code": "JO",
        "currency": "JOD",
        "currency_symbol": "$",
        "phone_code": 962,
        "country_phone_number_length": 10,
        "nationality": "Jordanian"
    },
    {
        "country_name": "Kazakhstan",
        "iso_code": "KZ",
        "currency": "KZT",
        "currency_symbol": "$",
        "phone_code": 7,
        "country_phone_number_length": 10,
        "nationality": "Kazakh"
    },
    {
        "country_name": "Kenya",
        "iso_code": "KE",
        "currency": "KES",
        "currency_symbol": "$",
        "phone_code": 254,
        "country_phone_number_length": 10,
        "nationality": "Kenyan"
    },
    {
        "country_name": "Kiribati",
        "iso_code": "KI",
        "currency": "AUD",
        "currency_symbol": "$",
        "phone_code": 686,
        "country_phone_number_length": 10,
        "nationality": "Kiribati"
    },
    {
        "country_name": "Korea North",
        "iso_code": "KP",
        "currency": "KPW",
        "currency_symbol": "$",
        "phone_code": 850,
        "country_phone_number_length": 10,
        "nationality": "Korea North"
    },
    {
        "country_name": "Korea South",
        "iso_code": "KR",
        "currency": "KRW",
        "currency_symbol": "$",
        "phone_code": 82,
        "country_phone_number_length": 10,
        "nationality": "Korea South"
    },
    {
        "country_name": "Kuwait",
        "iso_code": "KW",
        "currency": "KWD",
        "currency_symbol": "$",
        "phone_code": 965,
        "country_phone_number_length": 10,
        "nationality": "Kuwaiti"
    },
    {
        "country_name": "Laos",
        "iso_code": "LA",
        "currency": "LAK",
        "currency_symbol": "$",
        "phone_code": 856,
        "country_phone_number_length": 10,
        "nationality": "Laotian"
    },
    {
        "country_name": "Latvia",
        "iso_code": "LV",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 371,
        "country_phone_number_length": 10,
        "nationality": "Latvian"
    },
    {
        "country_name": "Lebanon",
        "iso_code": "LB",
        "currency": "LBP",
        "currency_symbol": "$",
        "phone_code": 961,
        "country_phone_number_length": 10,
        "nationality": "Lebonese"
    },
    {
        "country_name": "Lesotho",
        "iso_code": "LS",
        "currency": "LSL",
        "currency_symbol": "$",
        "phone_code": 266,
        "country_phone_number_length": 10,
        "nationality": "Lesotho"
    },
    {
        "country_name": "Liberia",
        "iso_code": "LR",
        "currency": "LRD",
        "currency_symbol": "$",
        "phone_code": 231,
        "country_phone_number_length": 10,
        "nationality": "Liberian"
    },
    {
        "country_name": "Libya",
        "iso_code": "LY",
        "currency": "LYD",
        "currency_symbol": "$",
        "phone_code": 218,
        "country_phone_number_length": 10,
        "nationality": "Libyan"
    },
    {
        "country_name": "Liechtenstein",
        "iso_code": "LI",
        "currency": "CHF",
        "currency_symbol": "$",
        "phone_code": 423,
        "country_phone_number_length": 10,
        "nationality": "Liechtensteiner"
    },
    {
        "country_name": "Lithuania",
        "iso_code": "LT",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 370,
        "country_phone_number_length": 10,
        "nationality": "Lithuanian"
    },
    {
        "country_name": "Luxembourg",
        "iso_code": "LU",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 352,
        "country_phone_number_length": 10,
        "nationality": "Luxembourger"
    },
    {
        "country_name": "Macedonia",
        "iso_code": "MK",
        "currency": "MKD",
        "currency_symbol": "$",
        "phone_code": 389,
        "country_phone_number_length": 10,
        "nationality": "Macedonian"
    },
    {
        "country_name": "Madagascar",
        "iso_code": "MG",
        "currency": "MGA",
        "currency_symbol": "$",
        "phone_code": 261,
        "country_phone_number_length": 10,
        "nationality": "Madagascan"
    },
    {
        "country_name": "Malawi",
        "iso_code": "MW",
        "currency": "MWK",
        "currency_symbol": "$",
        "phone_code": 265,
        "country_phone_number_length": 10,
        "nationality": "Malawian"
    },
    {
        "country_name": "Malaysia",
        "iso_code": "MY",
        "currency": "MYR",
        "currency_symbol": "$",
        "phone_code": 60,
        "country_phone_number_length": 10,
        "nationality": "Malaysian"
    },
    {
        "country_name": "Maldives",
        "iso_code": "MV",
        "currency": "MVR",
        "currency_symbol": "$",
        "phone_code": 960,
        "country_phone_number_length": 10,
        "nationality": "Maldivian"
    },
    {
        "country_name": "Mali",
        "iso_code": "ML",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 223,
        "country_phone_number_length": 10,
        "nationality": "Malian"
    },
    {
        "country_name": "Malta",
        "iso_code": "MT",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 356,
        "country_phone_number_length": 10,
        "nationality": "Maltese"
    },
    {
        "country_name": "Mexico",
        "iso_code": "MX",
        "currency": "MXN",
        "currency_symbol": "$",
        "phone_code": 52,
        "country_phone_number_length": 10,
        "nationality": "Mexican"
    },
    {
        "country_name": "Moldova",
        "iso_code": "MD",
        "currency": "MDL",
        "currency_symbol": "$",
        "phone_code": 373,
        "country_phone_number_length": 10,
        "nationality": "Moldovan"
    },
    {
        "country_name": "Monaco",
        "iso_code": "MC",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 377,
        "country_phone_number_length": 10,
        "nationality": "Monocan"
    },
    {
        "country_name": "Mongolia",
        "iso_code": "MN",
        "currency": "MNT",
        "currency_symbol": "$",
        "phone_code": 976,
        "country_phone_number_length": 10,
        "nationality": "Mongolian"
    },
    {
        "country_name": "Montenegro",
        "iso_code": "ME",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 382,
        "country_phone_number_length": 10,
        "nationality": "Montenegrin"
    },
    {
        "country_name": "Morocco",
        "iso_code": "MA",
        "currency": "MAD",
        "currency_symbol": "$",
        "phone_code": 212,
        "country_phone_number_length": 10,
        "nationality": "Moroccan"
    },
    {
        "country_name": "Namibia",
        "iso_code": "NA",
        "currency": "NAD",
        "currency_symbol": "$",
        "phone_code": 264,
        "country_phone_number_length": 10,
        "nationality": "Namibian"
    },
    {
        "country_name": "Nepal",
        "iso_code": "NP",
        "currency": "NPR",
        "currency_symbol": "$",
        "phone_code": 977,
        "country_phone_number_length": 10,
        "nationality": "Nepalese"
    },
    {
        "country_name": "Netherlands The",
        "iso_code": "NL",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 31,
        "country_phone_number_length": 10,
        "nationality": "Dutch"
    },
    {
        "country_name": "New Zealand",
        "iso_code": "NZ",
        "currency": "NZD",
        "currency_symbol": "$",
        "phone_code": 64,
        "country_phone_number_length": 10,
        "nationality": "New Zealand"
    },
    {
        "country_name": "Nicaragua",
        "iso_code": "NI",
        "currency": "NIO",
        "currency_symbol": "$",
        "phone_code": 505,
        "country_phone_number_length": 10,
        "nationality": "Nicaraguan"
    },
    {
        "country_name": "Nigeria",
        "iso_code": "NG",
        "currency": "NGN",
        "currency_symbol": "$",
        "phone_code": 234,
        "country_phone_number_length": 10,
        "nationality": "Nigerien"
    },
    {
        "country_name": "Norway",
        "iso_code": "NO",
        "currency": "NOK",
        "currency_symbol": "$",
        "phone_code": 47,
        "country_phone_number_length": 10,
        "nationality": "Norwegian"
    },
    {
        "country_name": "Oman",
        "iso_code": "OM",
        "currency": "OMR",
        "currency_symbol": "$",
        "phone_code": 968,
        "country_phone_number_length": 10,
        "nationality": "Oman"
    },
    {
        "country_name": "Pakistan",
        "iso_code": "PK",
        "currency": "PKR",
        "currency_symbol": "$",
        "phone_code": 92,
        "country_phone_number_length": 10,
        "nationality": "Pakistan"
    },
    {
        "country_name": "Peru",
        "iso_code": "PE",
        "currency": "PEN",
        "currency_symbol": "$",
        "phone_code": 51,
        "country_phone_number_length": 10,
        "nationality": "Peruvian"
    },
    {
        "country_name": "Philippines",
        "iso_code": "PH",
        "currency": "PHP",
        "currency_symbol": "$",
        "phone_code": 63,
        "country_phone_number_length": 10,
        "nationality": "Filipino"
    },
    {
        "country_name": "Poland",
        "iso_code": "PL",
        "currency": "PLN",
        "currency_symbol": "$",
        "phone_code": 48,
        "country_phone_number_length": 10,
        "nationality": "Polish"
    },
    {
        "country_name": "Portugal",
        "iso_code": "PT",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 351,
        "country_phone_number_length": 10,
        "nationality": "Portuguese"
    },
    {
        "country_name": "Qatar",
        "iso_code": "QA",
        "currency": "QAR",
        "currency_symbol": "$",
        "phone_code": 974,
        "country_phone_number_length": 10,
        "nationality": "Qatari"
    },
    {
        "country_name": "Romania",
        "iso_code": "RO",
        "currency": "RON",
        "currency_symbol": "$",
        "phone_code": 40,
        "country_phone_number_length": 10,
        "nationality": "Romanian"
    },
    {
        "country_name": "Russia",
        "iso_code": "RU",
        "currency": "RUB",
        "currency_symbol": "$",
        "phone_code": 7,
        "country_phone_number_length": 10,
        "nationality": "Russian"
    },
    {
        "country_name": "Saudi Arabia",
        "iso_code": "SA",
        "currency": "SAR",
        "currency_symbol": "$",
        "phone_code": 966,
        "country_phone_number_length": 10,
        "nationality": "Saudi"
    },
    {
        "country_name": "Senegal",
        "iso_code": "SN",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 221,
        "country_phone_number_length": 10,
        "nationality": "Senegalese"
    },
    {
        "country_name": "Serbia",
        "iso_code": "RS",
        "currency": "RSD",
        "currency_symbol": "$",
        "phone_code": 381,
        "country_phone_number_length": 10,
        "nationality": "Serbian"
    },
    {
        "country_name": "Singapore",
        "iso_code": "SG",
        "currency": "SGD",
        "currency_symbol": "$",
        "phone_code": 65,
        "country_phone_number_length": 10,
        "nationality": "Singaporean"
    },
    {
        "country_name": "Slovakia",
        "iso_code": "SK",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 421,
        "country_phone_number_length": 10,
        "nationality": "Slovakian"
    },
    {
        "country_name": "Slovenia",
        "iso_code": "SI",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 386,
        "country_phone_number_length": 10,
        "nationality": "Slovenian"
    },
    {
        "country_name": "Somalia",
        "iso_code": "SO",
        "currency": "SOS",
        "currency_symbol": "$",
        "phone_code": 252,
        "country_phone_number_length": 10,
        "nationality": "Somalian"
    },
    {
        "country_name": "South Africa",
        "iso_code": "ZA",
        "currency": "ZAR",
        "currency_symbol": "$",
        "phone_code": 27,
        "country_phone_number_length": 9,
        "nationality": "South Africa"
    },
    {
        "country_name": "South Sudan",
        "iso_code": "SS",
        "currency": "SSP",
        "currency_symbol": "$",
        "phone_code": 211,
        "country_phone_number_length": 10,
        "nationality": "South Sudan"
    },
    {
        "country_name": "Spain",
        "iso_code": "ES",
        "currency": "EUR",
        "currency_symbol": "$",
        "phone_code": 34,
        "country_phone_number_length": 10,
        "nationality": "Spanish"
    },
    {
        "country_name": "Sri Lanka",
        "iso_code": "LK",
        "currency": "LKR",
        "currency_symbol": "$",
        "phone_code": 94,
        "country_phone_number_length": 10,
        "nationality": "Sri Lankan"
    },
    {
        "country_name": "Sudan",
        "iso_code": "SD",
        "currency": "SDG",
        "currency_symbol": "$",
        "phone_code": 249,
        "country_phone_number_length": 10,
        "nationality": "Sudanese"
    },
    {
        "country_name": "Swaziland",
        "iso_code": "SZ",
        "currency": "SZL",
        "currency_symbol": "$",
        "phone_code": 268,
        "country_phone_number_length": 10,
        "nationality": "Swazi"
    },
    {
        "country_name": "Sweden",
        "iso_code": "SE",
        "currency": "SEK",
        "currency_symbol": "$",
        "phone_code": 46,
        "country_phone_number_length": 10,
        "nationality": "Swedish"
    },
    {
        "country_name": "Switzerland",
        "iso_code": "CH",
        "currency": "CHF",
        "currency_symbol": "$",
        "phone_code": 41,
        "country_phone_number_length": 10,
        "nationality": "Swiss"
    },
    {
        "country_name": "Syria",
        "iso_code": "SY",
        "currency": "SYP",
        "currency_symbol": "$",
        "phone_code": 963,
        "country_phone_number_length": 10,
        "nationality": "Syrian"
    },
    {
        "country_name": "Taiwan",
        "iso_code": "TW",
        "currency": "TWD",
        "currency_symbol": "$",
        "phone_code": 886,
        "country_phone_number_length": 10,
        "nationality": "Taiwanese"
    },
    {
        "country_name": "Tajikistan",
        "iso_code": "TJ",
        "currency": "TJS",
        "currency_symbol": "$",
        "phone_code": 992,
        "country_phone_number_length": 10,
        "nationality": "Tadzhik"
    },
    {
        "country_name": "Tanzania",
        "iso_code": "TZ",
        "currency": "TZS",
        "currency_symbol": "$",
        "phone_code": 255,
        "country_phone_number_length": 10,
        "nationality": "Tanzanian"
    },
    {
        "country_name": "Thailand",
        "iso_code": "TH",
        "currency": "THB",
        "currency_symbol": "$",
        "phone_code": 66,
        "country_phone_number_length": 10,
        "nationality": "Thai"
    },
    {
        "country_name": "Togo",
        "iso_code": "TG",
        "currency": "XOF",
        "currency_symbol": "$",
        "phone_code": 228,
        "country_phone_number_length": 10,
        "nationality": "Togolese"
    },
    {
        "country_name": "Tunisia",
        "iso_code": "TN",
        "currency": "TND",
        "currency_symbol": "$",
        "phone_code": 216,
        "country_phone_number_length": 10,
        "nationality": "Tunisian"
    },
    {
        "country_name": "Turkey",
        "iso_code": "TR",
        "currency": "TRY",
        "currency_symbol": "$",
        "phone_code": 90,
        "country_phone_number_length": 10,
        "nationality": "Turkish"
    },
    {
        "country_name": "Turkmenistan",
        "iso_code": "TM",
        "currency": "TMT",
        "currency_symbol": "$",
        "phone_code": 993,
        "country_phone_number_length": 10,
        "nationality": "Turkmenistan"
    },
    {
        "country_name": "Uganda",
        "iso_code": "UG",
        "currency": "UGX",
        "currency_symbol": "$",
        "phone_code": 256,
        "country_phone_number_length": 10,
        "nationality": "Ugandan"
    },
    {
        "country_name": "Ukraine",
        "iso_code": "UA",
        "currency": "UAH",
        "currency_symbol": "$",
        "phone_code": 380,
        "country_phone_number_length": 10,
        "nationality": "Ukrainian"
    },
    {
        "country_name": "United Arab Emirates",
        "iso_code": "AE",
        "currency": "AED",
        "currency_symbol": "$",
        "phone_code": 971,
        "country_phone_number_length": 10,
        "nationality": "United Arab Emirates"
    },
    {
        "country_name": "United Kingdom",
        "iso_code": "GB",
        "currency": "GBP",
        "currency_symbol": "$",
        "phone_code": 44,
        "country_phone_number_length": 10,
        "nationality": "United Kingdom"
    },
    {
        "country_name": "United States",
        "iso_code": "US",
        "currency": "USD",
        "currency_symbol": "$",
        "phone_code": 1,
        "country_phone_number_length": 10,
        "nationality": "American"
    },
    {
        "country_name": "Uruguay",
        "iso_code": "UY",
        "currency": "UYU",
        "currency_symbol": "$",
        "phone_code": 598,
        "country_phone_number_length": 10,
        "nationality": "Uruguayan"
    },
    {
        "country_name": "Uzbekistan",
        "iso_code": "UZ",
        "currency": "UZS",
        "currency_symbol": "$",
        "phone_code": 998,
        "country_phone_number_length": 10,
        "nationality": "Uzbek"
    },
    {
        "country_name": "Venezuela",
        "iso_code": "VE",
        "currency": "VEF",
        "currency_symbol": "$",
        "phone_code": 58,
        "country_phone_number_length": 10,
        "nationality": "Venezuelan"
    },
    {
        "country_name": "Vietnam",
        "iso_code": "VN",
        "currency": "VND",
        "currency_symbol": "$",
        "phone_code": 84,
        "country_phone_number_length": 10,
        "nationality": "Vietnam"
    },
    {
        "country_name": "Yemen",
        "iso_code": "YE",
        "currency": "YER",
        "currency_symbol": "$",
        "phone_code": 967,
        "country_phone_number_length": 10,
        "nationality": "Yemeni"
    }
]
   


export default countriesData;
